export const tooltipCss = ({ className, overrideCss, dottedText, } = {}) => {
    const tooltipBlock = [];
    const tooltipContent = [];
    const tooltipTip = [];
    if (!overrideCss) {
        tooltipBlock.push('base-tooltip');
        tooltipContent.push('base-tooltip__content');
        tooltipTip.push('base-tooltip__tip');
        if (dottedText) {
            tooltipContent.push('base-tooltip__content--dotted-text');
        }
    }
    if (className) {
        tooltipBlock.push(className);
        tooltipContent.push(`${className}__content`);
        tooltipTip.push(`${className}__tip`);
        if (dottedText) {
            tooltipContent.push(`${className}__content--dotted-text`);
        }
    }
    return {
        tooltipBlock: tooltipBlock.join(' '),
        tooltipContent: tooltipContent.join(' '),
        tooltipTip: tooltipTip.join(' '),
    };
};
//# sourceMappingURL=tooltipCss.js.map